import apiUrl from '../../../constants'
import axios from 'axios'
import {
  Validator
} from 'vee-validate'
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { decryptData } from '../../../../utils/crypto_utils';

export default {
  name: 'disputereport',
  components: {
    Paginate,
    VueElementLoading,
    Multiselect
  },
  props: [],

  data() {
    return {
      zoneList:[],
      hubList:[],
      DisputeReport:[],
      zone:[],
      zoneIdArr:[],
      HubId:[],
      resultCount:'',
      hubname:"",
      pageno:0,
      pagecount:0,
      isLoading:false,
      exportf:false,
      disableHub:false,
      zoneLoading:false,
      hubLoading:false,
      SearchHubIds:[],
      reportlink:'',
      tilldate:'',
      SearchZoneIds:[],
      SearchZIds:[],
      SearchHIds:[],
      RSCLoading:false,
      RSCList:[],
      RSCName:[],
      SearchRSCIds:[],
    }
  },

  computed: {

  },

  mounted() {
    var date = new Date();
    tilldate.max = date.toLocaleDateString('fr-CA', {year: 'numeric', month: '2-digit', day: '2-digit'});

    var userToken = window.localStorage.getItem('accessuserToken')
    this.myStr = userToken.replace(/"/g, '');
    this.role = window.localStorage.getItem('accessrole').toLowerCase().replace(/\s/g,'');
    console.log(this.role)
    this.getZoneData();
  },

  methods: {
    multiple(){
      let key = this.zone.length-1;
      if(this.zone.length>0 && this.zone[key].hubzoneid == 0){
        this.SearchZoneIds = [];
        this.zone = this.zone[key];

        for (let item of this.zoneList) {
          if (item.hubzoneid != 0) {
            this.SearchZoneIds.push(item);
          }
        }
      }

      if(this.zone.hubzoneid == 0){ return false; }
      else{ this.SearchZoneIds = []; return true; }
    },

    multipleHub(){
      let key = this.HubId.length-1;
      if(this.HubId.length>0 && this.HubId[key].HubID == 0){
        this.SearchHubIds = [];
        this.HubId = this.HubId[key];

        for (let item of this.hubList) {
          if (item.HubID != 0) {
            this.SearchHubIds.push(item.HubID);
          }
        }
      }

      if(this.HubId.HubID == 0){ return false; }
      else{ this.SearchHubIds = []; return true; }
    },

    multipleRSC(){
      let key = this.RSCName.length-1;
      if(this.RSCName.length>0 && this.RSCName[key].HubID == 0){
        this.SearchRSCIds = [];
        this.RSCName = this.RSCName[key];

        for (let item of this.RSCList) {
          if (item.HubID != 0) {
            this.SearchRSCIds.push(item.HubID);
          }
        }
      }

      if(this.RSCName.HubID == 0){ return false; }
      else{ this.SearchRSCIds = []; return true; }
    },

    addHubData() {
      let zData = this.zoneIdArr = [];  this.hubList = []; this.HubId = []; this.RSCList = []; this.RSCName = []; this.disableHub = false;
      if($.isArray(this.zone) === false){
        this.zone = new Array(this.zone);
      }

      this.zone.forEach(function (val) {
        zData.push({'hubzoneid':val.hubzoneid, 'hubzonename':val.hubzonename});
      });

      this.zoneIdArr = zData;

      if(zData.length===1 && zData[0].hubzoneid > 0){
        this.getHubData(zData[0].hubzoneid);
        // this.getRSCData(zData[0].hubzoneid);
      }else{
        this.disableHub = true;
      }
    },

    getPaginationData(pageNum) {
        this.pageno = (pageNum - 1) * 10
        this.getDisputeReport()
    },

    exportDisputeData(){
      if(this.reportlink){
        window.open(this.reportlink);
      }else{
        this.exportf = false;
        let allZoneHub = []
        const storedData = window.localStorage.getItem('zonewisehubdata');
        const hubdata = decryptData(storedData);
        if (hubdata && hubdata.length > 0) {
          hubdata.map((zoneData) => {
            if (zoneData.svcHubs && zoneData.svcHubs.length > 0) {
              zoneData.svcHubs.map((hub) => {
                allZoneHub.push(hub.HubID);
              })
            }
            if (zoneData.rscHubs && zoneData.rscHubs.length > 0) {
              zoneData.rscHubs.map((hub) => {
                allZoneHub.push(hub.HubID);
              })
            }
          })
        }
        this.input = ({
          hubid: this.SearchHIds.length>0? this.SearchHIds : allZoneHub,
          zoneid: this.SearchZIds,
          tilldate:this.tilldate
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'exportDisputeReport',
            'data': this.input,
            headers: {
                'Authorization': 'Bearer '+this.myStr
            }
        })
        .then(result => {
          if(result.data.code == 200){
            this.exportf = true; this.reportlink = result.data.data; window.open(this.reportlink);
          }else{
            this.exportf = false; this.reportlink = '';
          }
        }, error => {
          this.exportf = false; this.reportlink = ''; console.error(error); this.$alertify.error('Error Occured');
        })
      }
    },

    getDisputeReport(){
      this.isLoading = true; let zData = []; let hubArr = []; let RSCArr = [];
      let allZoneHub = []

      if(this.SearchZoneIds.length>0){
        zData = this.SearchZoneIds;
        const storedData = window.localStorage.getItem('zonewisehubdata');
        const hubdata = decryptData(storedData);
        if (hubdata && hubdata.length > 0) {
          hubdata.map((zoneData) => {
            if (zoneData.svcHubs && zoneData.svcHubs.length > 0) {
              zoneData.svcHubs.map((hub) => {
                allZoneHub.push(hub.HubID);
              })
            }
            if (zoneData.rscHubs && zoneData.rscHubs.length > 0) {
              zoneData.rscHubs.map((hub) => {
                allZoneHub.push(hub.HubID);
              })
            }
          })
        }
      }else{

        this.zone.forEach(function (val) {
          zData.push(val);
        });
      }

      if(this.SearchHubIds.length>0){
        hubArr = this.SearchHubIds;
      }else{
        if($.isArray(this.HubId) === false){
          this.HubId = new Array(this.HubId);
        }

        this.HubId.forEach(function (val) {
          hubArr.push(val.HubID);
        });
      }

      if(this.SearchRSCIds.length>0){
        RSCArr = this.SearchRSCIds;
      }else{
        if($.isArray(this.RSCName) === false){
          this.RSCName = new Array(this.RSCName);
        }

        this.RSCName.forEach(function (val) {
          RSCArr.push(val.HubID);
        });
      }

      let hubIdArr    = [...new Set([].concat(...hubArr.concat(RSCArr)))];
      this.SearchZIds = zData; this.SearchHIds = hubIdArr;

      this.input = ({
        hubid: this.SearchHIds.length>0? this.SearchHIds : allZoneHub,
        zoneid: this.SearchZIds,
        tilldate:this.tilldate,
        offset:this.pageno,
        limit:10
      })

      axios({
          method: 'POST',
          url: apiUrl.api_url + 'getDisputeReport',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer '+this.myStr
          }
        })
        .then(result => {

          if(result.data.code == 200){

            this.DisputeReport  = result.data.data;
            let totalRows       = result.data.count
            this.resultCount    = result.data.count
            this.exportf        = true;
            if (totalRows < 10) {
                 this.pagecount = 1
             } else {
                 this.pagecount = Math.ceil(totalRows / 10)
             }
           }else{
              this.exportf      = false; this.DisputeReport = []; this.resultCount = 0;
           }
           this.isLoading       = false;
          },
           error => {
             this.DisputeReport = []; this.isLoading = false; this.exportf = false; console.error(error); this.$alertify.error('Error Occured');
        })
    },

    //to get All Zone List
    getZoneData() {
      this.zoneList=[]
       this.zoneLoading = true;
      try {
        const zonedata = window.localStorage.getItem('zonedata');
        const decryptedZoneData = decryptData(zonedata);
        this.zoneList = [{ hubzoneid: '0', hubzonename: 'All Zone', hubzonecode: 'All Zone' }].concat(decryptedZoneData)
        this.zoneLoading = false;

      } catch (error) {
        this.zoneLoading = false;
      }
      // this.input = {}; this.zoneLoading = true; this.zoneList = [];
      // axios({
      //     method: 'POST',
      //     url: apiUrl.api_url + 'external/getallzones',
      //     data: this.input,
      //     headers: {
      //       'Authorization': 'Bearer '+this.myStr
      //     }
      //   })
      //   .then(result => {
      //     this.zoneLoading = false;

      //     if(this.role=='financemanager' || this.role=='admin' || this.role === 'ops-pan'){
      //       this.zoneList = [{hubzoneid:'0', hubzonename:'All Zone', hubzonecode:'All Zone'}].concat(result.data.zone.data);
      //     }else{
      //       if(window.localStorage.getItem('accesszone')){
      //         result.data.zone.data.map(item => {
      //           let obj = window.localStorage.getItem('accesszone').split(",").find(el => el == item.hubzoneid);
      //           if(obj) this.zoneList.push(item);
      //         });
      //       }else{ this.zoneList = result.data.zone.data; }
      //     }
      //   }, error => {
      //     this.zoneLoading = false; console.error(error);
      //   })
    },

    //to get All Zone Wise Hub List
    getHubData(zoneid) {
      if(zoneid==""){
        return false;
      }
      this.hubLoading = true;
      this.hubList=[];
      this.RSCList=[];
       try {

        const storedDataEncrypted = window.localStorage.getItem("zonewisehubdata");
        const hubdata = decryptData(storedDataEncrypted);
          if (hubdata && hubdata.length > 0) {

           const filterHubData = hubdata.filter(
             (obj) => obj.HubZoneId == zoneid,
           );

          
           if (filterHubData.length > 0) {
             this.hubList = [
               { HubID: "0", HubName: "All Hub", HubCode: "All Hub" },
               ...filterHubData[0].svcHubs,
             ];

             this.RSCList = [
               { HubID: "0", HubName: "All RSC", HubCode: "All RSC" },
               ...filterHubData[0].rscHubs,
             ];
           }
         }

         this.hubLoading = false;
       } catch (error) {
         this.hubLoading = false;
         return false;
       }

      // this.input = ({
      //     zoneid: zoneid
      // })
      // this.hubLoading = true;
      // axios({
      //     method: 'POST',
      //     url: apiUrl.api_url + 'external/getzonesvc',
      //     'data': this.input,
      //     headers: {
      //       'Authorization': 'Bearer '+this.myStr
      //     }
      //   })
      //   .then(result => {
      //     this.hubLoading = false; this.HubId = []; this.hubList = [];
      //     if(result.data.hub.code == 200){
      //       this.hubList = [{HubID:'0', HubName:'All Hub', HubCode:'All Hub'}].concat(result.data.hub.data);
      //     }
      //   }, error => {
      //     this.hubLoading = false; console.error(error);
      //   })
    },

    //to get All Zone Wise RSC List
    getRSCData(zoneid) {
      // if(zoneid==""){
      //   return false;
      // }
      // this.input = ({
      //     zoneid: zoneid
      // })
      // this.RSCLoading = true;
      // axios({
      //     method: 'POST',
      //     url: apiUrl.api_url + 'external/getzonersc',
      //     'data': this.input,
      //     headers: {
      //       'Authorization': 'Bearer '+this.myStr
      //     }
      //   })
      //   .then(result => {
      //     this.RSCLoading = false; this.RSCName = []; this.RSCList = [];
      //     if(result.data.rsc.code == 200){
      //       this.RSCList = [{HubID:'0', HubName:'All RSC', HubCode:'All RSC'}].concat(result.data.rsc.data);
      //     }
      //   }, error => {
      //     this.RSCLoading = false; console.error(error)
      //   })
    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.pageno = 0; this.exportf = false;
          this.reportlink = ''; this.getDisputeReport()
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    resetForm() {
      this.tilldate = this.zone = ''; this.hubList = this.HubId = this.RSCList = this.RSCName = this.DisputeReport = this.SearchZIds = this.SearchHIds = [];
      this.exportf = this.disableHub = false; this.pageno = this.resultCount = 0; this.reportlink = '';
      this.$validator.reset(); this.errors.clear();
    },

    generateUrl(key) {
      this.input = ({
        BatchID : '',
        Reason : '',
        FileName: this.fullyDecode(key),
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getfilelist',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      })
      .then(result => {
        const a = document.createElement('a');
        a.href = result.data.data;
        a.download = ''; // You can set a custom file name here
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }, error => {
        this.disableButton = false; this.ReasonLoading = false; this.DepositLoading = false;
        console.error(error)
      })
    },

    fullyDecode(url) {
      let decodedUrl = url;
      let prevUrl;
      do {
        prevUrl = decodedUrl;
        decodedUrl = decodeURIComponent(decodedUrl);
      } while (prevUrl !== decodedUrl);
      return decodedUrl;
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/disputereport/disputereport.component.js